// dropdownHelper.ts
import React, { useState, useEffect } from 'react';
import { KatDropdown } from "@amzn/katal-react";
import { getApiBaseUrl } from 'src/config/api';
import {makeApiRequest} from "src/components/helper/apiUtils";
import {METHOD_GET} from "src/components/constants/constants";
const testPilotApi = getApiBaseUrl();

interface KatOptionInput {
    name: string;
    value: string;
    disabled?: boolean;
}

interface DropdownHelperProps {
    query: string;
    label: string;
    value: string;
    onChange: (val: string) => void;
}

export const DropDownHelper: React.FC<DropdownHelperProps> = ({ query, label, value, onChange }) => {
    const [options, setOptions] = useState<KatOptionInput[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetchOptions();
    }, [query]);

    const fetchOptions = async () => {
        setIsLoading(true);
        setError(null);

        try {
            //const response = await fetch(testPilotApi + query);
           const response = await makeApiRequest(testPilotApi, METHOD_GET, query, '');

            if (!response.ok) {
                throw new Error(`API responded with status: ${response.status}`);
            }

            const data = await response.json();
            //const data = response;

            if (data && data.options && Array.isArray(data.options)) {

                const uniqueOptions = Array.from(new Set(data.options.map((option: any) => option.value)))
                    .map(value => {
                        return data.options.find((option: any) => option.value === value);
                    });

                const formattedOptions: KatOptionInput[] = uniqueOptions.map((option: any) => ({
                    name: option.label || option.value,
                    value: option.value,
                    disabled: option.disabled || false
                }));

                setOptions(formattedOptions);
            }
        } catch (error) {
            console.error(`Error fetching options for ${label}:`, error);
            setOptions([]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <KatDropdown
            searchable
            label={label}
            options={options || []}
            value={value}
            onChange={(e: CustomEvent) => {
                e.stopPropagation();
                onChange(e.detail.value)}
            }
        />
    );
};

// Usage example:
// <DropDownHelper query="/businessQuery" label="Business" />